/** @jsxImportSource @emotion/react */
import React from 'react'

import { LOGO_BTIME } from '../Constants'
import { getFieldInPx } from '../../_helpers/fieldInPixels'
import { usePdfOptionsForm } from '../../../../../components/pdf/options/_form/PdfOptionsFormHandler'
import Qrcode from '../../../../../containers/qrcodes/Qrcode'

const CompleteTemplate = ({ qrcode }) => {
  const form = usePdfOptionsForm()
  const logoSize = getFieldInPx(form, 'logoSize')

  const defaultCSS = {
    fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "SF Pro Display", "Nunito", "Montserrat", sans-serif',
    lineHeight: '110%'
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      width={form.templateWidth + 'cm'}
      height={form.templateWidth / (16 / 9) + 'cm'}
      id="svgQrcode"
      viewBox="4.547 229.496 623.512 340.101"
    >
      <path
        d="M 0 575.597 H 33.7 c -16.082 0 -29.154 -12.64 -29.154 -28.19 V 255 c 0 -15.55 13.072 -28.19 29.154 -30.19 h 565.205 c 16.082 0 29.154 12.64 29.154 38 v 283.721 c 0 15.55 -13.072 28.19 -29.154 28.19 z"
        style={{ fill: form.bgColor }}
      />
      <path
        fill="#FFF"
        d="M560.166 489.573H405.12c-15.641 0-28.372-12.731-28.372-28.372V306.155c0-15.641 12.731-28.372 28.372-28.372h155.046c15.641 0 28.372 12.64 28.372 28.372v155.046c.001 15.641-12.731 28.372-28.372 28.372z"
      />
      <g fill="#FFF">
        <path d="M464.593 509.125h2.182c1.091 0 1.91.637 1.91 1.637 0 1.182-.909 1.728-1.91 1.728h-1.182v2.091h-1v-5.456zm1.091 2.546h1c.637 0 1-.273 1-.818 0-.637-.455-.818-1-.818h-1.091l.091 1.636zM473.322 512.58c0 1.182-.727 2.182-2.001 2.182s-2.001-.909-2.001-2.092c0-1.273.727-2.182 2.001-2.182 1.274.001 2.001.819 2.001 2.092zm-3 0c0 .818.364 1.364 1 1.364.637 0 1-.546 1-1.364 0-.909-.364-1.364-1-1.364-.637 0-1 .455-1 1.364zM474.777 510.579c.455 1.728.637 2.728.727 3.183.091-.455.273-1.182.818-3.183h.909c.546 2.092.727 2.728.727 3.183.091-.455.273-1 .727-3.183h1l-1.273 4.092h-1c-.364-1.546-.637-2.546-.727-3.092-.091.455-.364 1.546-.727 3.092h-1.091l-1.091-4.092h1.001zM481.143 512.853c0 .637.273 1.182.909 1.182.546 0 .727-.273.818-.455h1c-.182.546-.637 1.273-1.819 1.273-1.364 0-1.91-1-1.91-2.091 0-1.273.637-2.182 1.91-2.182 1.364 0 1.819 1 1.819 2.001v.364l-2.727-.092zm1.819-.637c0-.546-.273-1-.818-1s-.818.455-.909 1h1.727zM484.78 511.671v-1.091h1v.727c.182-.455.637-.818 1.364-.818v.909c-.818 0-1.364.273-1.364 1.364v1.819h-1v-2.91zM488.509 512.853c0 .637.273 1.182.909 1.182.546 0 .727-.273.818-.455h1c-.182.546-.637 1.273-1.819 1.273-1.364 0-1.91-1-1.91-2.091 0-1.273.637-2.182 1.91-2.182 1.364 0 1.819 1 1.819 2.001v.364l-2.727-.092zm1.818-.637c0-.546-.273-1-.818-1-.546 0-.818.455-.909 1h1.727zM495.693 508.852v5.729h-.909v-.455c-.182.364-.546.546-1.182.546-1 0-1.728-.818-1.728-2.091 0-1.273.727-2.182 1.819-2.182.637 0 .909.273 1.091.455v-2.092l.909.09zm-2.819 3.728c0 .909.364 1.364.909 1.364.818 0 1-.637 1-1.364 0-.727-.182-1.364-.909-1.364-.637.091-1 .546-1 1.364zM498.785 508.852h1v2.182c.182-.273.546-.546 1.182-.546 1.091 0 1.637.909 1.637 2.092 0 1.182-.637 2.182-1.819 2.182-.637 0-.909-.182-1.091-.546v.455h-.909v-5.819zm2.819 3.728c0-.727-.273-1.273-.909-1.273-.727 0-1 .455-1 1.364 0 .727.273 1.364.909 1.364.636-.091 1-.637 1-1.455zM504.059 510.579c.455 1.637.909 2.819.909 3.183.091-.455.364-1.364.909-3.183h1l-1.364 4.183c-.364 1.182-.727 1.546-1.637 1.546h-.455v-.818h.273c.455 0 .637-.182.818-.727l-1.546-4.183 1.093-.001z" />
      </g>
      <image width="3236" height="1117" href={LOGO_BTIME} transform="translate(437.456 516.46) scale(.0279)"></image>
      <foreignObject width={302.433} height={269} x={44.067} y={277.783}>
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          style={{
            ...defaultCSS,
            fontWeight: 'bolder',
            color: `${form.titleColor}`,
            fontSize: `${form.titleSize}px`,
            textAlign: `${form.titleAlign?.id}`
          }}
        >
          {form.title}
        </div>
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          style={{
            ...defaultCSS,
            color: `${form.subtitleColor}`,
            paddingTop: `${form.subtitleSpacing}cm`,
            fontSize: `${form.subtitleSize}px`,
            textAlign: `${form.subtitleAlign?.id}`
          }}
        >
          {form.subtitle}
        </div>
        <div style={{ display: 'flex', justifyContent: `${form.logoAlign?.id}` }}>
          <img src={form.customLogo?.preview} width={logoSize} style={{ paddingTop: `${form.logoSpacing}cm` }} />
        </div>
      </foreignObject>
      {form.activationDetails && qrcode?.data?.name && (
        <foreignObject width={160} height={20} x={402} y={468}>
          <div
            style={{
              ...defaultCSS,
              textAlign: 'center',
              fontSize: '8.5px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical'
            }}
          >
            {qrcode?.data?.name?.toUpperCase()}
          </div>
        </foreignObject>
      )}

      <Qrcode x="403" y="304" qrcode={qrcode} size={160} />
    </svg>
  )
}

export default CompleteTemplate
